import { Link } from "react-router-dom";
import { To } from "history";

// material-ui
import { ButtonBase } from "@mui/material";
import { SxProps } from "@mui/system";

// project import
// import Logo from './LogoMain';
// import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH, USER_ROLE } from "utils/Constants";
import logo from "assets/images/logo-login.png";
import useAuth from "hooks/useAuth";
import Logo from "./LogoMain";
import LogoIcon from "./LogoIcon";

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => {
  const { user } = useAuth();
  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={
        !to
          ? user && user.role === USER_ROLE.ADMIN
            ? "/admin/users"
            : "/stores"
          : to
      }
      sx={sx}
    >
      <>
        {/* {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />} */}
        {isIcon ? (
          <img
            src={logo}
            style={{ height: "50px", width: "50px" }}
            alt="logo"
          />
        ) : (
          <Logo reverse={reverse} />
        )}
      </>
    </ButtonBase>
  );
};

export default LogoSection;
